import FlexRow from "../../../../components/base/FlexRow";
import Modal from "../../../../components/base/Modal";
import { toastSuccess } from "../../../../components/base/Toast";
import ColorPicker from "../../../../components/form/ColorPicker";
import TextBox from "../../../../components/form/TextBox";
import ToggleSwitch from "../../../../components/form/ToggleSwitch";
import Tagify from "../../../../components/tagify/Tagify";
import { API_ROUTES } from "../../../../core/Constants";
import { getUser, useHub } from "../../../../core/Global";
import JobStatus from "../models/JobStatus";


interface IProps {
  status?: JobStatus
  onClose?: () => void
  onUpdate?: () => void
}
export default function JobStatusEditModal(props: IProps) {

  const hub = useHub();
  const user = getUser();

  return (
    <Modal id="modal-edit-jobstatus"
      title="Edit Job Status"
      buttonText="Update Status"
      staticBackdrop visible open
      onOpen={() => {
        $("#txt-editstatus-name").focus();
      }}
      onClose={props.onClose}
      onSubmit={(body, callback) => {

        if (user?.isSuperAdmin) {
          if (!body.ownerUserId || body.ownerUserId == "" || body.ownerUserId.length < 10) {
            window.showFormError("ownerUserId", "Please choose a valid user!", true, "modal-edit-jobstatus");
            if (callback) callback();
            return;
          }
        }

        if (!body.name || body.name == "" || body.name.length < 2) {
          window.showFormError("name", "Please write a valid name!", false, "modal-edit-jobstatus");
          if (callback) callback();
          return;
        }

        hub.Put(API_ROUTES.JobStatuses + props.status?.id, body, res => {
          if (res.success) {
            toastSuccess("Job status has been updated successfully!");
            if (props.onUpdate) props.onUpdate()
          }
          if (callback) callback(res);
        })

      }}>
      <div>
        {
          user?.isSuperAdmin &&
          <>
            <div className="fs-7 fw-bold">
              Assign to
              <span id="ownerUserId-err" className="small text-danger mx-2 form-error"></span>
            </div>
            <Tagify name="ownerUserId" id="drp-edit-ownerUserId" placeholder="Select a Customer" apiUrl={API_ROUTES.TagifyCustomers} selectedId={props.status?.ownerUserId} single block />
          </>
        }

        <FlexRow className="mb-10">
          <ColorPicker id="color-edit-jobstatus" width={30} className="me-2" name="color" color={props.status?.color} />
          <div className="flex-grow-1">
            <TextBox id="txt-editstatus-name" name="name" block marginBottom={0} inlineStyle mediumText noTextError placeholder="Status Name" defaultValue={props.status?.name} />
          </div>
        </FlexRow>

        <ToggleSwitch name="noteRequired" raw label="Note Required" checked={props.status?.noteRequired} />

      </div>
    </Modal>
  )
}